// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1C_h4","title":"BackImages_title__1ca0w","images":"BackImages_images__tN_b1"};